import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getPizzaFaqQuestions = (cityName, siteTitle, vehicleType) => [
  {
    question: `How much does pizza food ${vehicleType} catering cost in ${cityName}?`,
    answer: `Pizza food ${vehicleType} catering costs in ${cityName} depend on guest count, menu style, and service length. Smaller private events often start around a few hundred dollars, while larger corporate events, weddings, and festivals may range higher. ${siteTitle} lets you compare real quotes from pizza food ${vehicleType}s so you can find great food that fits your budget, with clear pricing and no hidden fees.`
  },
  {
    question: `What types of pizzas can a pizza food ${vehicleType} serve at my event?`,
    answer: `Pizza food ${vehicleType}s offer a wide variety of options, from classic margherita to more adventurous combinations like Florentine pizzas with ricotta and roasted red peppers. Many pizza ${vehicleType}s also provide delicious sides, salads, and beverages, making it easy to tailor the menu to your event.`
  },
  {
    question: `Are pizza food ${vehicleType}s good for large events?`,
    answer: `Yes — pizza food ${vehicleType}s are one of the most popular catering options for corporate events and large gatherings. Pizza is easy to serve, crowd-friendly, and customizable for different dietary needs. ${siteTitle} works with experienced pizza ${vehicleType}s that regularly serve corporate campuses and high-volume events.`
  },
  {
    question: `Can pizza food ${vehicleType}s accommodate vegetarian, vegan, or gluten-free diets?`,
    answer: `Most pizza food ${vehicleType}s offer vegetarian and vegan pizza options, and many can accommodate gluten-free requests using cauliflower crusts or alternative flours. When submitting your catering request, you can note any dietary needs, and ${siteTitle} will match you with pizza ${vehicleType}s that can meet your guests' preferences.`
  },
  {
    question: `How far in advance should I book a pizza food ${vehicleType} for catering?`,
    answer: `For best availability, we recommend booking a pizza food ${vehicleType} 3–6 weeks in advance, especially for weddings, summer events, and corporate catering. However, last-minute pizza catering may be possible depending on availability. Submitting your request early gives you the most menu options and scheduling flexibility.`
  }
];

function PizzaFaq() {
  const { city_name, site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getPizzaFaqQuestions(city_name, site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default PizzaFaq;
